import { render, staticRenderFns } from "./DisableSelfEval.vue?vue&type=template&id=2989829c&scoped=true&"
import script from "./DisableSelfEval.vue?vue&type=script&lang=js&"
export * from "./DisableSelfEval.vue?vue&type=script&lang=js&"
import style0 from "./DisableSelfEval.vue?vue&type=style&index=0&id=2989829c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2989829c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VIcon,VSimpleTable})
